import { Tooltip } from "@mui/material";
import React from "react";

const VDSTooltip = ({ 
  children, 
  title, 
  placement = "bottom", 
  arrow = true,
  ...props 
}) => {
  return (
    <Tooltip 
      placement={placement} 
      arrow={arrow} 
      title={title}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default VDSTooltip;
